import React, { useEffect, useState } from 'react';

export default function HealthBar() {
  const [health, setHealth] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    const fetchHealth = () => {
      fetch(`${process.env.PUBLIC_URL}/api/health`)
        .then(r => r.json())
        .then(data => {
          if (mounted) {
            setHealth(data);
            setError(null);
          }
        })
        .catch(err => {
          if (mounted) setError(err.message || 'unreachable');
        });
    };
    fetchHealth();
    const t = setInterval(fetchHealth, 10_000);
    return () => {
      mounted = false;
      clearInterval(t);
    };
  }, []);

  let dot = '#888';
  let label = 'connecting…';
  if (error) {
    dot = 'var(--red)';
    label = `unreachable: ${error}`;
  } else if (health) {
    if (health.status === 'ok') {
      dot = 'var(--green)';
      label = `ready · ${health.model}`;
    } else {
      dot = 'var(--orange)';
      label = health.modelReady === false ? 'pulling model…' : 'degraded';
    }
  }

  return (
    <div
      style={{
        background: 'var(--bg-card)',
        borderBottom: '1px solid var(--border)',
        padding: '8px 24px',
        fontSize: 12,
        color: 'var(--text-dim)',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
      }}
    >
      <span
        style={{
          display: 'inline-block',
          width: 10,
          height: 10,
          borderRadius: '50%',
          background: dot,
        }}
      />
      {label}
      {health && health.supportedGames && (
        <span style={{ marginLeft: 'auto' }}>
          games: {health.supportedGames.join(', ') || '(none)'}
        </span>
      )}
    </div>
  );
}
